import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import * as React from 'react';

type IAnnouncePostModalProps = {
  open: boolean;
  onClose: () => void;
  onClickAnnounce: () => void;
  onClickPost: () => void;
  announcementLoading: boolean;
  loading: boolean;
  postType?: string;
  postVerb?: string;
  postVerbPresentTense?: string;
};

export const AnnouncePostModal: React.FC<IAnnouncePostModalProps> = (props) => {
  const normalPostButton = React.useRef(null);
  const postVerb = props.postVerb?.toLowerCase();
  const postType = props.postType?.toLowerCase();
  const postVerbPresentCapitalized = props.postVerbPresentTense
    ? props.postVerbPresentTense.charAt(0).toUpperCase() +
      props.postVerbPresentTense.toLowerCase().slice(1)
    : undefined;

  return (
    <AlertDialog
      leastDestructiveRef={normalPostButton}
      isOpen={props.open}
      onClose={props.onClose}
      blockScrollOnMount={false}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>
          Announce this {postType || 'post'}?
        </AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>
          Announcements are shown at the top of the feed and sent immediately
          over email. {postVerbPresentCapitalized || 'Posting'} normally will
          notify users based on individual notification settings.
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button
            ref={normalPostButton}
            colorScheme="gray"
            isLoading={props.loading}
            isDisabled={props.announcementLoading}
            onClick={props.onClickPost}
          >
            No, {postVerb || 'post'} Normally
          </Button>
          <Button
            ml="2"
            isLoading={props.announcementLoading}
            isDisabled={props.loading}
            onClick={props.onClickAnnounce}
          >
            Yes, Announce
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
